export const updates = [
  { id: 1, date: '07-29', title: '《月光宫殿》第128话更新：真相即将揭晓', tag: '连载中', tagColor: 'primary' },
  { id: 2, date: '07-29', title: '《恶女的救赎》第三季正式回归，首话已发布', tag: '新季开播', tagColor: 'accent' },
  { id: 3, date: '07-28', title: '《全知读者视角》番外篇·外传三话连更', tag: '爆更', tagColor: 'accent' },
  { id: 4, date: '07-28', title: '《公爵的契约未婚妻》第96话：命运交汇', tag: '连载中', tagColor: 'primary' },
  { id: 5, date: '07-27', title: '《某天成为公主》完结篇已上线，全卷可阅', tag: '已完结', tagColor: 'secondary' },
  { id: 6, date: '07-27', title: '《剑与魔法》世界观设定集独家公开', tag: '专题', tagColor: 'accent' },
  { id: 7, date: '07-26', title: '《废柴逆袭》第214话更新，剧情迎来大转折', tag: '连载中', tagColor: 'primary' },
  { id: 8, date: '07-26', title: '社区读友推荐：《星界旅人》口碑飙升中', tag: '推荐', tagColor: 'accent' },
  { id: 9, date: '07-25', title: '《前世今生缘》番外·婚后续篇甜蜜上线', tag: '番外', tagColor: 'secondary' },
];

export const cards = [
  { id: 1, title: '月光宫殿', coverSeq: 'moon-palace', author: '金秀雅', genre: '奇幻恋爱', status: '连载至128话', desc: '穿越到古代朝鲜的现代女孩，在月光下的宫殿中与王世子展开一段跨越时空的命运之恋。细腻画风搭配紧凑剧情，人气持续飙升中。' },
  { id: 2, title: '恶女的救赎', coverSeq: 'villainess-redemption', author: '朴智恩', genre: '穿越逆袭', status: '第三季连载中', desc: '重生为小说中的恶毒女配，她决心改写命运。但这一切的背后，隐藏着比原著更加惊人的秘密，救赎之路才刚刚开始。' },
  { id: 3, title: '公爵的契约未婚妻', coverSeq: 'duke-fiancee', author: '崔允熙', genre: '宫廷恋爱', status: '连载至96话', desc: '一纸荒唐契约，让她成为北方公爵的未婚妻。冰封的城堡中，两人的关系在试探与信任中悄然变化，权谋与柔情相互交织。' },
  { id: 4, title: '某天成为公主', coverSeq: 'became-princess', author: '李瑞元', genre: '幻想喜剧', status: '全卷已完结', desc: '一觉醒来变身帝国最受宠的小公主，她决定好好享受这段童话般的生活。然而宫廷暗流涌动，公主的身份并非看上去那么简单。' },
  { id: 5, title: '废柴逆袭', coverSeq: 'underdog-rise', author: '韩在熙', genre: '热血逆袭', status: '连载至214话', desc: '被全校视为最弱存在的他，意外觉醒了传说中的隐藏职业。从底层一步步向上攀登，友情与信念在战斗中不断淬炼，热血与感动并存。' },
  { id: 6, title: '星界旅人', coverSeq: 'star-traveler', author: '安素妍', genre: '科幻冒险', status: '已完结118话', desc: '在不远的未来，人类开始探索星际边界。少女莉娜意外获得穿越星门的能力，在不同文明之间展开一场关于归宿与自由的壮丽冒险。' },
  { id: 7, title: '前世今生缘', coverSeq: 'past-life-romance', author: '郑多恩', genre: '轮回恋爱', status: '全卷已完结', desc: '三生三世的执念，换来今生的重逢。命运让他们一次次相遇又分离，这次能否打破轮回的诅咒，携手走向永恒。画风唯美催泪，韩漫经典之作。' },
];

export const aboutContent = {
  title: '关于韩漫网',
  paragraphs: [
    '韩漫网是国内专注于韩国漫画资源整理与阅读推荐的平台，致力于为韩漫爱好者提供一站式的韩漫全集、韩漫完结及韩漫完整版浏览服务。无论你是想追更热门连载，还是寻找韩漫全本已完结的经典佳作，这里都能满足你的需求。',
    '我们的团队每日持续追踪韩漫最新动态，覆盖恋爱、奇幻、穿越、逆袭、科幻等多种题材。所有韩漫大全作品均经过精心筛选与分类，配合下拉式阅读体验，让你畅享沉浸式追漫乐趣。从新人入坑到资深漫迷，韩漫网都是你值得信赖的韩漫推荐伙伴。',
  ],
  stats: [
    { value: '5,200+', label: '收录作品' },
    { value: '360+', label: '每日更新话数' },
    { value: '89万+', label: '月活跃读者' },
  ],
};

export const indexTopics = [
  { id: 1, title: '🔥 本周热门连载', count: 48, desc: '追更党必看，热度实时更新', icon: 'ri-fire-line' },
  { id: 2, title: '✨ 韩漫完结精选', count: 236, desc: '一口气看到结局', icon: 'ri-check-double-line' },
  { id: 3, title: '💕 恋爱甜宠专题', count: 152, desc: '从校园到宫廷，甜度拉满', icon: 'ri-heart-line' },
  { id: 4, title: '⚔️ 热血逆袭之路', count: 89, desc: '从废柴到巅峰的爽快体验', icon: 'ri-sword-line' },
  { id: 5, title: '🌌 奇幻世界漫游', count: 114, desc: '魔法、异界、超能力全收录', icon: 'ri-planet-line' },
  { id: 6, title: '🏰 宫廷权谋大戏', count: 67, desc: '宫斗、权谋、步步惊心', icon: 'ri-building-2-line' },
  { id: 7, title: '🔄 穿越重生合集', count: 198, desc: '换个身份，重启人生', icon: 'ri-loop-left-line' },
  { id: 8, title: '🎭 悬疑惊悚地带', count: 43, desc: '脑洞大开的烧脑神作', icon: 'ri-ghost-line' },
  { id: 9, title: '📖 新人入坑指南', count: 25, desc: '零基础快速找到你的第一本韩漫', icon: 'ri-book-open-line' },
];

export const carouselItems = [
  { id: 1, title: '月光宫殿', subtitle: '穿越时空的宫廷恋歌，2026年度人气TOP3', tag: '奇幻恋爱', coverSeq: 'carousel-moon' },
  { id: 2, title: '恶女的救赎', subtitle: '恶女逆天改命，第三季高能回归', tag: '穿越逆袭', coverSeq: 'carousel-villainess' },
  { id: 3, title: '废柴逆袭', subtitle: '从底层到巅峰，热血与信念的成长史诗', tag: '热血励志', coverSeq: 'carousel-underdog' },
  { id: 4, title: '星界旅人', subtitle: '星际漫游，寻找归属与自由的壮丽冒险', tag: '科幻冒险', coverSeq: 'carousel-star' },
  { id: 5, title: '某天成为公主', subtitle: '全卷已完结，童话般的帝国公主物语', tag: '幻想喜剧', coverSeq: 'carousel-princess' },
];

export const features = [
  { id: 1, title: '海量韩漫大全', desc: '收录超过五千部韩漫作品，涵盖韩漫全集与韩漫完结资源，每日持续扩充中', icon: 'ri-stack-line' },
  { id: 2, title: '下拉式畅快阅读', desc: '专为连贯阅读优化，向下滑动即可无缝衔接下一话，沉浸体验不中断', icon: 'ri-arrow-down-line' },
  { id: 3, title: '全本完结精选', desc: '精心整理韩漫全本已完结经典，从新作到完结番外一应俱全，告别追更焦虑', icon: 'ri-checkbox-circle-line' },
  { id: 4, title: '每日追踪更新', desc: '编辑团队全天候追踪最新话更新动态，第一时间推送热门连载进度', icon: 'ri-timer-flash-line' },
  { id: 5, title: '精准韩漫推荐', desc: '基于题材、画风、人气的多维度推荐系统，帮你轻松找到下一部心头好', icon: 'ri-thumb-up-line' },
];

export const contactContent = {
  title: '联系我们',
  subtitle: '商务合作 · 内容投稿 · 问题反馈',
  desc: '如果你有韩漫推荐、内容投稿或商务合作需求，欢迎通过以下方式与我们取得联系。韩漫网团队期待与每一位韩漫爱好者交流，共同打造更好的韩漫大全阅读社区。',
  methods: [
    { icon: 'ri-mail-line', label: '联系邮箱', value: 'contact@hanmanwang.com' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '韩漫网官方' },
    { icon: 'ri-notification-3-line', label: '更新通知', value: '关注获取每日更新提醒' },
  ],
};

export const appContent = {
  title: '随时随地 · 畅享韩漫',
  subtitle: '手机浏览器访问 m.hanmanwang.com 即可体验移动端下拉式阅读',
  features: ['适配手机屏幕，流畅下拉式阅读', '支持离线缓存，地铁通勤也能看', '夜间模式护眼，深夜追更不伤眼', '更新推送提醒，热门连载不错过'],
};

export const topics = [
  { id: 1, name: '月光宫殿', count: '128万', hot: true },
  { id: 2, name: '穿越重生', count: '96万', hot: true },
  { id: 3, name: '宫廷恋爱', count: '85万', hot: true },
  { id: 4, name: '恶女的救赎', count: '78万', hot: true },
  { id: 5, name: '废柴逆袭', count: '72万', hot: false },
  { id: 6, name: '韩漫完结', count: '67万', hot: true },
  { id: 7, name: '甜宠漫画', count: '59万', hot: false },
  { id: 8, name: '奇幻冒险', count: '54万', hot: false },
  { id: 9, name: '全知读者视角', count: '48万', hot: false },
  { id: 10, name: '韩漫推荐', count: '43万', hot: false },
  { id: 11, name: '公爵的契约', count: '39万', hot: false },
];

export const comments = [
  { id: 1, name: '糯米团子', avatarSeq: 'avatar-1', date: '2026-07-28', rating: 5, content: '韩漫网的完结精选真的太好了！之前到处找某天成为公主的完整版，在这里一次性看完了全部，下拉式阅读体验超流畅。已经安利给所有追韩漫的朋友了～' },
  { id: 2, name: '夜雨寄北', avatarSeq: 'avatar-2', date: '2026-07-27', rating: 5, content: '作为一个入坑三年的韩漫迷，韩漫网是我用过最趁手的韩漫大全平台。更新速度快，分类清晰，月光宫殿和恶女的救赎都在追，每天打开看更新已经成为习惯了。' },
  { id: 3, name: '星辰大海', avatarSeq: 'avatar-3', date: '2026-07-26', rating: 4, content: '从贴吧过来的，这里的韩漫推荐确实很靠谱。之前一直不知道看什么，按照推荐榜单找到了好几部超好看的韩漫全本已完结作品，追漫效率直接拉满。希望以后能出更多专题合集。' },
];

export const faqItems = [
  { id: 1, question: '韩漫网上的韩漫全集是免费的吗？', answer: '韩漫网作为一个韩漫大全整理与推荐平台，所有收录的韩漫全集、韩漫完结及韩漫完整版作品均向读者免费开放浏览，支持下拉式阅读模式，无需付费即可畅享海量韩漫资源。' },
  { id: 2, question: '如何找到韩漫全本已完结的作品？', answer: '你可以在顶部导航进入「漫画索引」页面，选择「韩漫完结精选」专题，或在搜索中使用完结标签进行筛选。我们的编辑团队已将热门的韩漫全本已完结作品整理成合集，方便你一次性畅读到底。' },
  { id: 3, question: '韩漫网的更新频率是怎样的？', answer: '韩漫网的编辑团队保持每日更新追踪，热门连载通常在原作发布后24小时内完成整理。你可以关注「更新动态」栏目实时了解最新话发布情况，也可以订阅更新通知获取第一手消息。' },
  { id: 4, question: '移动端怎么使用韩漫网的下拉式阅读？', answer: '直接用手机浏览器访问韩漫网即可自动适配移动端界面，无需下载额外应用。在阅读页面中，只需向下滑动屏幕即可无缝加载下一话内容，下拉式阅读体验经过专门优化，加载快、翻页顺滑。' },
];

export const mediaItems = [
  { id: 1, title: '2026韩漫年度盛典回顾', desc: '盘点过去一年最受欢迎的韩漫作品与作者名场面，从月光宫殿到恶女的救赎，回顾那些让我们心动与泪目的瞬间。', coverSeq: 'media-1', date: '2026-07-20' },
  { id: 2, title: '编辑精选：十部冷门佳作推荐', desc: '除了热门连载，韩漫大全中还有许多被埋没的宝藏。我们的编辑团队精心挑选了十部口碑炸裂但热度不高的韩漫，每部都值得一看。', coverSeq: 'media-2', date: '2026-07-15' },
  { id: 3, title: '韩漫创作幕后：画师访谈特辑', desc: '走进韩漫创作的世界，我们邀请到三位人气画师分享他们的创作日常、灵感来源，以及对韩漫行业未来的展望与期待。', coverSeq: 'media-3', date: '2026-07-10' },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '月光宫殿', genre: '奇幻恋爱', heat: '🔥 128万', status: '连载中', trend: 'up' },
  { id: 2, rank: 2, title: '恶女的救赎', genre: '穿越逆袭', heat: '🔥 106万', status: '连载中', trend: 'up' },
  { id: 3, rank: 3, title: '某天成为公主', genre: '幻想喜剧', heat: '🔥 95万', status: '已完结', trend: 'stable' },
  { id: 4, rank: 4, title: '废柴逆袭', genre: '热血逆袭', heat: '89万', status: '连载中', trend: 'up' },
  { id: 5, rank: 5, title: '公爵的契约未婚妻', genre: '宫廷恋爱', heat: '76万', status: '连载中', trend: 'stable' },
];

export const footerInfo = {
  siteName: '韩漫网',
  intro: '韩漫网是国内专业的韩漫全集与韩漫完结资源整理平台，提供韩漫完整版免费下拉式阅读服务。覆盖韩漫全本已完结经典与最新连载，是韩漫爱好者不可错过的韩漫大全追更社区。',
  quickLinks: [
    { label: '更新动态', href: '#updates' },
    { label: '焦点推荐', href: '#carousel' },
    { label: '漫画索引', href: '#index' },
    { label: '热度榜单', href: '#ranking' },
    { label: '常见问题', href: '#faq' },
    { label: '联系我们', href: '#contact' },
  ],
  partners: { title: '合作伙伴' },
};